export function flushLogBuffer(): string {
  return "";
}
